export default __webpack_public_path__ + "static/media/ad.be00411d.svg";